import { createReactRenderer } from 'helpers/react-renderer';

let RenderedComponent: null | any;
let currentId: TSFixMe;

history.onChangeState(
  {
    name: ['item.views.item', 'item_group.views.item_group'],
    tab: 'ecommerce',
    id: undefined,
  },
  ({ record_id: id }) => {
    currentId = id;

    if (!RenderedComponent) {
      import(/* webpackChunkName: "tinymce" */ './tinymce').then((module) => {
        RenderedComponent = createReactRenderer({
          component: module.RichTextEditor,
          selector: '[data-react-root="RichTextEditor"]',
        });

        RenderedComponent.mount();
      });
    } else {
      RenderedComponent.mount();
    }
  },
  ({ name, record_id: id }) => {
    if (name === 'item.views.item' && currentId === id) return;
    RenderedComponent?.unmount();
  }
);
